import { create } from "zustand";

interface SidebarStore {
  expandedSection: string | null;
  setExpandedSection: (section: string | null) => void;
}

export const useSidebarStore = create<SidebarStore>((set) => ({
  expandedSection: null,
  setExpandedSection: (section) => set({ expandedSection: section }),
}));
